import { motion } from "framer-motion";
import { SectionHeading, EASE } from "./motionPrimitives";

const STEPS = [
    {
        id: "process-step-audit",
        num: "01",
        title: "Audit & discovery",
        desc: "We map your funnel, tech stack and market position, then quantify exactly where growth is leaking.",
    },
    {
        id: "process-step-architecture",
        num: "02",
        title: "Strategy & architecture",
        desc: "You get a 90-day roadmap: channel mix, budget split, AI use cases and the KPIs we'll be judged on.",
    },
    {
        id: "process-step-execution",
        num: "03",
        title: "Launch & execution",
        desc: "Campaigns, content and automations go live in tight sprints — no six-month homework projects.",
    },
    {
        id: "process-step-scaling",
        num: "04",
        title: "Optimize & scale",
        desc: "We double down on what converts, cut what doesn't, and compound the results month after month.",
    },
];

export default function Approach() {
    return (
        <section id="approach" className="relative bg-navy py-20 lg:py-28 overflow-hidden">
            <div
                aria-hidden="true"
                className="absolute inset-0 opacity-40 pointer-events-none"
                style={{
                    backgroundImage:
                        "linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px)",
                    backgroundSize: "88px 88px",
                }}
            />
            <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <SectionHeading
                    dark
                    eyebrow="How we work"
                    title="A process built for momentum."
                />

                <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
                    {STEPS.map((s, i) => (
                        <motion.div
                            key={s.id}
                            data-testid={s.id}
                            initial={{ opacity: 0, y: 36 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.2 }}
                            transition={{ duration: 0.7, delay: i * 0.1, ease: EASE }}
                            className="group relative bg-white/5 border border-white/10 rounded-2xl p-8 hover:border-gold/50 hover:bg-white/[0.07] transition-all duration-300"
                        >
                            <span className="font-mono text-5xl font-semibold text-gold/25 group-hover:text-gold/60 transition-colors duration-300">
                                {s.num}
                            </span>
                            <h3 className="mt-6 font-display text-xl font-bold text-white">
                                {s.title}
                            </h3>
                            <p className="mt-3 text-sm text-mist leading-relaxed">
                                {s.desc}
                            </p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
